import { Component, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { LocationAttribute } from '../Models/location-attribute.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { PrettifyPipe } from '../../../../Common/prettify.pipe';

export class DialogResult {
    Result: boolean;
    Text: string;
}

@Component({
    selector: 'aw-location-attribute-modal',
    templateUrl: './location-attribute-modal.component.html',
    styles: [`
        [mat-dialog-content] {
            min-height: 450px;
        }

        .row-container {
            display: table;
            width: 950px;
            min-height: 30px;
            border-bottom: rgba(49, 99, 162, 0.58) 2px solid;
            background-color: rgba(64, 222, 34, 0.1);
            padding-top: 4px;
        }

        .row-label {
            width: 25%;
            display: table-cell;
            height: 30px;
            text-align: right;
            padding-right: 10px;
            font-weight: bold;
        }

        .row-item {
            width: 75%;
            min-height: 30px;
            display: table-cell;
            text-align: left;
        }
    `],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, PrettifyPipe]
})
export class LocationAttributeModalComponent {
    DialogTitle: string;
    DialogDescription: string;
    DialogConfirmButtonText: string = "close";
    DialogCancelButtonText: string = "cancel";
    MetadataUrl: string;
    Name: string;
    dialogResult: DialogResult = new DialogResult();
    public attribute: LocationAttribute;
    constructor(public dialogRef: MatDialogRef<LocationAttributeModalComponent>) { }

    setAttribute(attribute: LocationAttribute) {
        this.attribute = attribute;
    }

    closeDialog() {
        this.dialogRef.close(this.dialogResult);
    }
}
